import type { IconSvgObject } from './types';

const ResetPasswordIcon: IconSvgObject = [
  ["path", { d: "M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75334 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75334 2.5 12 2.5C15.8956 2.5 19.2436 4.84478 20.7095 8.2M21.5 5.5L21.025 8.675L18 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.25 11V9.25C10.25 8.2835 11.0335 7.5 12 7.5C12.9665 7.5 13.75 8.2835 13.75 9.25V11M15.5 12V15.5C15.5 16.0523 15.0523 16.5 14.5 16.5H9.5C8.94772 16.5 8.5 16.0523 8.5 15.5L8.5 12C8.5 11.4477 8.94772 11 9.5 11H14.5C15.0523 11 15.5 11.4477 15.5 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ResetPasswordIcon;
